import { useEffect, useState } from "react";
import { Avatar, Box, IconButton, Menu, Typography, MenuItem, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../hooks/redux";
import { PATHS } from "../../../constants";
import { useAction } from "../../../hooks/actions";
import useScreenSize from "../../../hooks/useScreenSize";
import { handleLogoutFromSystem } from "../../../helpers/siteHelper";
import DefaultAvatarIcon from "../../components/icons/DefaultAvatarIcon";
import ArrowIcon from "../../components/icons/Header/ArrowIcon";
import LogoutIcon from "../../components/icons/Header/LogoutIcon";
import UserIcon from "../../components/icons/Header/UserIcon";
import { useLazyGetProfileInfoQuery } from "../../../middleware/usersApi";

const ProfileDropdown = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isSmallDescktop = useScreenSize().width < 1560;
  const {
    token,
    info: { firstName, lastName, avatarLink },
  } = useAppSelector((state) => state.users);
  const [anchorEl, setAnchorEl] = useState(null);
  const { setAuthStep, logout } = useAction();
  const [getProfileInfo, { isError, isLoading }] = useLazyGetProfileInfoQuery();

  useEffect(() => {
    const requiredNecessaryValues = [firstName, lastName];
    const definedRequiredNecessaryValues = requiredNecessaryValues.filter((value) => value);
    if (requiredNecessaryValues.length !== definedRequiredNecessaryValues.length) {
      getProfileInfo(token);
    }
    // eslint-disable-next-line
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (isError) {
    return null;
  }

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }
  return (
    <Box>
      <IconButton
        aria-expanded={anchorEl}
        disableRipple
        onClick={handleClick}
        sx={{
          display: "flex",
          gap: "12px",
          padding: "0",
          mr: "0",
          borderRadius: "0",
        }}
      >
        <Box>
          {avatarLink ? (
            <Avatar
              alt="avatar"
              src={avatarLink}
              sx={{
                backgroundColor: "var(--accent)",
                height: isSmallDescktop ? "46px" : "48px",
                width: isSmallDescktop ? "46px" : "48px",
              }}
            />
          ) : (
            <Box className="default-avatar-icon">
              <DefaultAvatarIcon />
            </Box>
          )}
        </Box>
        <Box className="user-name">
          {firstName} {lastName}
        </Box>
        <Box sx={{ margin: "0 0 8px 4px" }}>
          <ArrowIcon />
        </Box>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        sx={{
          "& .MuiMenu-list": {
            p: "10px",
            width: "222px",
          },
        }}
      >
        <MenuItem
          className="menu-item"
          onClick={() => {
            navigate(PATHS.PROFILE_ROUTE);
            handleClose();
          }}
        >
          <UserIcon />
          <Typography sx={{ ml: "18px" }}>{t("label:profile")}</Typography>
        </MenuItem>

        <MenuItem className="menu-item" onClick={() => handleLogoutFromSystem(setAuthStep, logout)}>
          <LogoutIcon />
          <Typography sx={{ ml: "18px" }}>{t("label:logout")}</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default ProfileDropdown;
